import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  ApiURL = environment.ApiURL + '/admin';

  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  getAllContacts(): Observable<any> {
    return this.http.get(this.ApiURL + '/Contacts', { headers: this.headers_token });
  }

  deleteContact(Id: any): Observable<any> {
    return this.http.delete(this.ApiURL + '/Contacts/' + Id, { headers: this.headers_token });
  }
}
